module.exports = "//static.hsappstatic.net/react-codemirror/static-1.6842/theme/hubspot-canvas-dark.sass"